export default {"src":"/_next/static/media/download-circle-fill.e48ebb13.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};